import { Box } from '@material-ui/core';
import i18n from '../../../i18n';

const bulletStyles = {
  borderRadius: '50%',
  minWidth: 14,
  height: 14,
};

export const MapLegend = () => {
  return (
    <Box
      style={{
        position: 'absolute',
        bottom: 35,
        left: 0,
        margin: 25,
        zIndex: 5,
        backgroundColor: 'white',
        padding: 8,
        color: 'var(--color-main-orange)',
        border: '1px solid var(--color-main-orange)',
        borderRadius: 8,
        lineHeight: 1,
        gap: 6,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box style={{ display: 'flex', alignItems: 'center', gap: 3 }}>
        <Box
          style={{
            ...bulletStyles,
            backgroundColor: 'var(--color-main-orange)',
          }}
        />
        <Box>{i18n.t('mapLegend.allChildren') as unknown as string}</Box>
      </Box>
      <Box style={{ display: 'flex', alignItems: 'center', gap: 3 }}>
        <Box
          style={{
            ...bulletStyles,
            backgroundColor: 'var(--color-blue-slider)',
          }}
        />
        <Box>{i18n.t('mapLegend.onlyLocalChildren') as unknown as string}</Box>
      </Box>
    </Box>
  );
};
